import { FC, ReactNode } from 'react'
import Link from '@mui/material/Link'
import Avatar from '@mui/material/Avatar'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Footer, MainContainer } from './styled'

function Copyright(props: any) {
  return (
    <Footer>
      {'Copyright ©'}
      <Link color='inherit' href='https://hssoft.com/'>
        HS-Soft
      </Link>
      {new Date().getFullYear()}
    </Footer>
  )
}

export const AdminComponent: FC<{ children: ReactNode }> = ({ children }) => (
  <Container component='main' maxWidth='xs' sx={{ marginTop: '150px' }}>
    <CssBaseline />
    <MainContainer>
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      {children}
    </MainContainer>
    <Copyright sx={{ mt: 8, mb: 4 }} />
  </Container>
)
